import { Whisky } from "./whisky";
import { Storage } from "@ionic/storage";
import { DefaultDistilleries } from "./defaultDistilleries";
import { DefaultBottlers } from "./default_bottlers";
import { Events } from "ionic-angular/util/events";
//import { Platform } from "ionic-angular/platform/platform";
//import { File } from "@ionic-native/file";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
//import { User } from "../providers/user";
import { WhiskySync } from "./sync";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
//import { Observable } from "rxjs/Observable";
//import { WhiskyDB_fb } from "./fbDb";

export class WhiskyDB {
  static inFirebase = false;

  static whisky: Whisky[] = [];
  static distilleries: any[] = [];
  private static shelves: any[] = [];
  static regions: string[] = [];
  static ratings: string[] = [];
  static bottlers: string[] = [];
  static basket: Whisky[] = [];
  static imageTimestamps = {};
  static imageSizes = {};

  static networkUp: boolean = true;

  static sequence: number = 0;
  static db: WhiskyDB = new WhiskyDB();

  //private toaster: ToastController;
  private storage: Storage;
  private events: Events;
  //private platform: Platform;
  //private file: File;
  //private user: User;

  private dbSync: WhiskySync;

  static doNothing()
  {

  }

  static getShelves()  : any[]  {
    return this.shelves;
  }
  static addShelf(shelf: string){
    if(this.inFirebase)
    {
      //WhiskyDB_fb.addShelf(shelf);
      this.doNothing()
    } else {
      this.shelves.push(shelf);
    }
  }
  static removeShelf(toRemoveKey: string) {
    if(this.inFirebase) {
      //WhiskyDB_fb.removeShelf(toRemoveKey);
      this.doNothing();
    } else {
      WhiskyDB.shelves = WhiskyDB.shelves.filter(item => {
        return item != toRemoveKey;
      });
    }

  }
  static emptyShelves()
  {
    if(this.inFirebase)
    {
      //WhiskyDB_fb.emptyShelves();
      this.doNothing();
      this.shelves = [];
    } else {
      this.shelves = [];
    }
  }

  static syncShelves() {
  /*
    let shelves = [];
    console.log("----");
    WhiskyDB_fb.shelves.forEach( value => {
      value.forEach(val =>  {
        console.log(val.shelf);
        shelves.push(val.shelf);
      }); 

      this.shelves = shelves;
      return;      
    });  */

  }


  //setUser(u: User) {
  //  this.user = u;
  //}

  setStorage(s: Storage) {
    this.storage = s;
  }
  setEvent(e: Events) {
    this.events = e;
  }
  /*
  setPlatform(p: Platform) {
    this.platform = p;
  }
  setFile(f: File) {
    this.file = f;
  } */

  loadAll() {
    console.log("Loading database from local storage.")
    this.loadDistilleries();
    this.loadBottlers();
    this.loadShelves();
    this.loadRatings();
    this.loadWhisky();
    this.loadBasket();

    this.storage.get("sequence").then(data => {
      console.log("loaded sequence='" + data + "'");
      if (data != null) {
        WhiskyDB.sequence = Number.parseInt(data, 10);
        console.log("parsed=" + WhiskyDB.sequence);
      }
    });
    if (this.dbSync == null) {
      this.dbSync = new WhiskySync();
      //this.dbSync.startAutoSync(this.storage, this.user, this.toaster);
    }
  }

  sync() {
    if(WhiskyDB.whisky.length > 0)
      WhiskyDB.sequence = new Date().getTime(); // use timestamp
    else 
      WhiskyDB.sequence++;
      
    this.storage.set("sequence", WhiskyDB.sequence + "");
    console.log("sequence=" + WhiskyDB.sequence);

    // TODO: Save to cloud
    //this.dbSync.saveToCloud(this.dbSync);
  }

  sortDistilleries() {
    WhiskyDB.distilleries.sort((a: any, b: any) => {
      return a && b ? a.Distillery.localeCompare(b.Distillery) : -1;
    });
  }

  saveDistilleries(sync: boolean = true) {
    // Sort before saving
    this.sortDistilleries();

    this.storage
      .set("distilleries_map", JSON.stringify(WhiskyDB.distilleries))
      .then(val => {
        console.log("Saved distilleries");
      });
    if (sync) this.sync();
  }
  loadDistilleries() {
    console.log("Loading distilleries");

    // Load from storage (json)
    this.storage.get("distilleries_map").then(data => {
      // Parse the json
      WhiskyDB.distilleries = JSON.parse(data);

      // If empty, defailt it
      if (WhiskyDB.distilleries == null || WhiskyDB.distilleries.length == 0) {
        WhiskyDB.distilleries = DefaultDistilleries.default;
        WhiskyDB.sequence = 0;
        this.sortDistilleries();

        console.log("Saving initial distilleries");
        // save default
        this.saveDistilleries(true);
      }
      console.log("Extract regions");
      // Extract regions
      var set = new Set<string>();
      WhiskyDB.distilleries.forEach(value => {
        //console.log("add " + value.Region + " " + set.size);
        set.add(value.Region);
      });

      WhiskyDB.regions = Array.from(set);
      //console.log(WhiskyDB.regions);

      WhiskyDB.regions.sort((a, b) => {
        return a.localeCompare(b);
      });
      //console.log(WhiskyDB.regions);

      console.log("Checking for missing distilleries");
      DefaultDistilleries.default.forEach(w => {
        var index = -1;
        for (var i = 0; i < WhiskyDB.distilleries.length; i++) {
          if (WhiskyDB.distilleries[i].Distillery === w.Distillery) {
            index = i;
            break;
          }
        }
        if (index == -1) {
          WhiskyDB.distilleries.push(w);
          console.log("Addded: " + w.Distillery);
        }
      });

      // Check URL's
      var cnt2 = 0;
      var cnt = 0;
      WhiskyDB.distilleries.forEach(function(w, pos, ar) {
        if (w.URL == null || w.URL === "") {
          let index = -1;
          for (var i = 0; i < DefaultDistilleries.default.length; i++) {
            //console.log(DefaultDistilleries.default[i].Distillery + " ===" + w.Distillery);
            if (DefaultDistilleries.default[i].Distillery === w.Distillery) {
              index = i;
              break;
            }
          }
          if (index > -1) {
            ar[pos].URL = DefaultDistilleries.default[index].URL;
            cnt++;
            //console.log("Setting url: " + ar[pos].Distillery + " " + ar[pos].URL);
          }
        } else cnt2++;
      });

      // Check SMWS Code
      let cnt3 = 0
      WhiskyDB.distilleries.forEach(function(w, pos, ar) {
        if (w.SMWS == null || w.SMWS === "") {
          ar[pos].SMWS = ""

          let index = -1;
          for (var i = 0; i < DefaultDistilleries.default.length; i++) {
            //console.log(DefaultDistilleries.default[i].Distillery + " ===" + w.Distillery);
            if (DefaultDistilleries.default[i].Distillery === w.Distillery) {
              index = i;
              break;
            }
          }
          if (index > -1) {
            ar[pos].SMWS = DefaultDistilleries.default[index].SMWS;
            cnt3++;
            //console.log("Setting SMWS Code "+ ar[pos].Distillery + " " + DefaultDistilleries.default[index].SMWS)
            //console.log(DefaultDistilleries.default[index])
            //console.log("Setting url: " + ar[pos].Distillery + " " + ar[pos].URL);
          }
          if ( ar[pos].SMWS == null ) {
            ar[pos].SMWS = ""
          }
        } 
      });

      console.log("Added " + cnt + " URL's");
      console.log("Added " + cnt3 + " SMWS");
      console.log("Already have " + cnt2 + " URL's");
    });
  }

  saveBottlers(sync: boolean = true) {
    this.storage
      .set("bottlers_map", JSON.stringify(WhiskyDB.bottlers))
      .then(val => {
        console.log("Saved bottlers");
      });
    if (sync) this.sync();
  }

  loadBottlers() {
    console.log("Loading bottlers");

    // Load from storage (json)
    this.storage.get("bottlers_map").then(data => {
      // Parse the json
      WhiskyDB.bottlers = JSON.parse(data);

      // If empty, defailt it
      if (WhiskyDB.bottlers == null || WhiskyDB.bottlers.length == 0) {
        WhiskyDB.bottlers = DefaultBottlers.default;
        console.log("Saving initial bottlers");
        WhiskyDB.bottlers.sort(function(a, b) {
          return a.localeCompare(b);
        });
        this.saveBottlers(true);
      }
    });
  }

  saveShelves(sync: boolean = true) {
    this.storage
      .set("shelf_map", JSON.stringify(WhiskyDB.shelves))
      .then(val => {
        console.log("Saved shelves");
      });
    if (sync) this.sync();
  }
  loadShelves() {
    console.log("Loading shelves");

    // Load from storage (json)
    this.storage.get("shelf_map").then(data => {
      // Parse the json
      WhiskyDB.shelves = JSON.parse(data);

      // If empty, defailt it
      if (WhiskyDB.shelves == null || WhiskyDB.shelves.length == 0) {
        WhiskyDB.shelves = [
          "Top Shelf",
          "Middle Shelf",
          "Bottom Shelf",
          "Wishlist"
        ];
        console.log("Saving initial shelves");

        // save default
        this.saveShelves(true);
      }
    });
  }

  saveRatings(sync: boolean = true) {
    this.storage
      .set("ratings_map", JSON.stringify(WhiskyDB.ratings))
      .then(val => {
        console.log("Saved ratings");
      });
    if (sync) this.sync();
  }

  loadRatings() {
    console.log("Loading ratings");

    // Load from storage (json)
    this.storage.get("ratings_map").then(data => {
      // Parse the json
      WhiskyDB.ratings = JSON.parse(data);

      // If empty, defailt it
      if (WhiskyDB.ratings == null || WhiskyDB.ratings.length == 0) {
        WhiskyDB.ratings = ["£", "££", "£££", "££££", "£££££"];
        console.log("Saving initial ratings");

        // save default
        this.saveRatings(true);
      }
    });
  }

  sortWhisky() {
    WhiskyDB.whisky.sort((a: Whisky, b: Whisky) => {
      if (a.distillery === b.distillery) {
        return a.name.localeCompare(b.name);
      } else {
        return a.distillery.localeCompare(b.name);
      }
    });
  }
  saveWhisky(sync: boolean = true) {
    this.sortWhisky();
    this.storage.set("image_sizes", JSON.stringify(WhiskyDB.imageSizes));
    this.storage.set(
      "image_timestamps",
      JSON.stringify(WhiskyDB.imageTimestamps)
    );

    this.storage
      .set("whisky_list", JSON.stringify(WhiskyDB.whisky))
      .then(val => {
        console.log("Saved whisky");
      });
    if (sync) this.sync();
  }

  loadWhisky() {
    this.storage.get("image_sizes").then(data => {
      WhiskyDB.imageSizes = JSON.parse(data);
      if (WhiskyDB.imageSizes == null) WhiskyDB.imageSizes = {};
    });

    this.storage.get("image_timestamps").then(data => {
      WhiskyDB.imageTimestamps = JSON.parse(data);
      if (WhiskyDB.imageTimestamps == null) WhiskyDB.imageTimestamps = {};
    });

    this.storage.get("whisky_list").then(data => {
      if (data != null && data.length > 0) {
        WhiskyDB.whisky = JSON.parse(data);
      }

      WhiskyDB.whisky.forEach((w: Whisky) => {
        if (w.image) {
          if (w.image !== "yes") {
            this.saveImage(w, w.image, new Date().getTime(), false);
            w.image = "yes";
            console.log("moved image for " + w.name);
          }
          if (
            WhiskyDB.imageSizes[w.name] == null ||
            WhiskyDB.imageSizes[w.name] == 0
          )
            this.loadImage(w); // initialize size
        }
      });
      this.events.publish("whisky:updated");
    });
  }

  saveImage(
    whisky: Whisky,
    image: string,
    timestamp: number,
    sync: boolean = true
  ) {
    if (image.length > 0) {
      this.storage.set("image:" + whisky.name, image).then(val => {
        console.log("saved image " + whisky.name);
      });
      WhiskyDB.imageTimestamps[whisky.name] = timestamp;
      this.storage
        .set("image-timestamp:" + whisky.name, timestamp)
        .then(val => {
          console.log("set image timestmap: " + timestamp);
        });
    } else {
      this.storage.remove("image:" + whisky.name).then(val => {
        console.log("removed image " + whisky.name);
      });
    }
    if (sync) this.sync();
  }

  loadImage(
    whisky: Whisky,
    forSave: boolean = false,
    s3 = null,
    sub: string = null,
    n: number = 0
  ) {
    if (whisky.image === "yes") {
      this.storage.get("image-timestamp:" + whisky.name).then(val => {
        let ts = val;
        WhiskyDB.imageTimestamps[whisky.name] = ts;
        console.log("timestamp for " + whisky.name + " = " + ts);
        this.storage
          .get("image:" + whisky.name)
          .then(data => {
            if (data != null) {
              console.log("image loaded for " + whisky.name);
              console.log("Image size=" + data.length);
              WhiskyDB.imageSizes[whisky.name] = data.length;
              if (!forSave)
                this.events.publish("image:loaded", data, whisky.name, ts);
              else
                this.events.publish(
                  "image:loaded_for_save",
                  data,
                  whisky.name,
                  s3,
                  sub,
                  n
                );
            } else {
              console.log("null image loaded for " + whisky.name);
              if (!forSave)
              this.events.publish("image:loaded", null, whisky.name, ts);
            else
              this.events.publish(
                "image:loaded_for_save",
                null,
                whisky.name,
                s3,
                sub,
                n
              );

            }
          })
          .catch(err => {
            console.log(
              "Error getting image for " + whisky.name + " " + err.message
            );
          });
      });
    }
  }

  sortBasket() {
    WhiskyDB.basket.sort((a: Whisky, b: Whisky) => {
      if (a.distillery === b.distillery) {
        return a.name.localeCompare(b.name);
      } else {
        return a.distillery.localeCompare(b.name);
      }
    });
  }
  saveBasket(sync: boolean = true) {
    this.sortBasket();
    this.storage.set("basket", JSON.stringify(WhiskyDB.basket)).then(val => {
      console.log("Saved basket");
    });
    if (sync) this.sync();
  }
  loadBasket() {
    this.storage.get("basket").then(data => {
      if (data != null && data.length > 0) {
        WhiskyDB.basket = JSON.parse(data);
      }
      this.events.publish("basket:updated");
    });
  }

  getAllData() {
    let allData: any = {
      magic: "whisky1.0",
      sequence: WhiskyDB.sequence,
      distilleries: WhiskyDB.distilleries,
      bottlers: WhiskyDB.bottlers,
      shelves: WhiskyDB.shelves,
      ratings: WhiskyDB.ratings,
      whisky: WhiskyDB.whisky,
      basket: WhiskyDB.basket
    };
    return JSON.stringify(allData);
  }

  loadAllData(
    raw: string,
    alert: AlertController,
    toaster: ToastController = null
  ) {
    let allData = JSON.parse(raw);
    var ok = true;

    if (allData.magic !== "whisky1.0") {
      console.log("Unable to load data file magic number not identified");
      if (alert) {
        let confirm = alert.create({
          title: "File error",
          message: "Cloud file does not appear to be a valid db.",
          buttons: ["OK"]
        });
        confirm.present();
      } else {
        let toast = toaster.create({
          message: "Cloud file appears to be invalid.",
          duration: 3000
        });
        toast.present();
      }
      return;
    }

    let merge = false;

    console.log(
      "New seq=" + allData.sequence + " current=" + WhiskyDB.sequence
    );
    if (allData.sequence <= WhiskyDB.sequence) {
      console.log(
        "data is older than currenet version: " +
          allData.sequence +
          " " +
          WhiskyDB.sequence
      );
      if (alert) {
        let confirm = alert.create({
          title: "Restore older database?",
          message:
            "Current sequence is " +
            (new Date(WhiskyDB.sequence).toUTCString()) +
            ". Sequence to be loaded from cloud is " +
            (new Date(allData.sequence).toUTCString()) +
            ".",
          buttons: [
            {
              text: "Overwrite",
              handler: () => {
                ok = true;
              }
            },
            {
              text: "Cancel",
              handler: () => {
                ok = false;
              }
            }
          ]
        });
        confirm.present();
        if (ok) {
          console.log("overwriting db");
        } else {
          return;
        }
      } else {
        merge = true;
      }
    }
    WhiskyDB.sequence = allData.sequence;
    WhiskyDB.distilleries = allData.distilleries;
    WhiskyDB.bottlers = allData.bottlers;
    WhiskyDB.shelves = allData.shelves;
    WhiskyDB.ratings = allData.ratings;
    if(!merge) {
      WhiskyDB.whisky = allData.whisky;      
    } else {
      // Merge by timestamp
      this.mergeWhiskies(allData.whisky);
    }
    WhiskyDB.basket = allData.basket;
    
    this.storage.set("sequence", "" + WhiskyDB.sequence);

    this.saveDistilleries(false);
    this.saveBottlers(false);
    this.saveRatings(false);
    this.saveShelves(false);
    this.saveWhisky(false);
    this.saveBasket(false);

    this.loadAll(); // Reload
    console.log("Restored data from file");
  }

  mergeWhiskies(old: any)
  {
    // Compare each record in the "old" file.
    // If it's either missing, or if the timestamp on the record is newer, take it
    old.forEach(ow => {
      WhiskyDB.whisky.forEach(dw => {
        console.log("old_ts:" + ow.timestamp + " dw_t:" + dw.timestamp);
        
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/data/db.ts